"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Bar = _interopRequireDefault(require("../Bar/Bar"));

var _chainFunction = _interopRequireDefault(require("chain-function"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _constants = require("../utils/constants");

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Title = _interopRequireDefault(require("../Title/Title"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _bar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/bar.css") : void 0);

var _messageBox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/message-box.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _bar.default), _messageBox.default));
var MESSAGE_BOX_TYPES = process.env.NODE_ENV !== "production" ? ['default', 'confirmation', 'error', 'success', 'warning', 'information'] : {};
/** A **MessageBox** displays a dialog with a simple message to the user.
 * Contrary to the **Popover**, message box can relay messages unrelated to the
 * UI, such as technical errors. This component inherits the look and behavior
 * of the **Dialog** (excluding dragging/resizing).
 *
 * @returns {Node} MessageBox component
 */

var _ref2 = /*#__PURE__*/_react.default.createElement("span", {
  "data-autofocus": true,
  tabIndex: "-1"
});

function MessageBox(_ref) {
  var _context, _classnames, _context2;

  var actions = _ref.actions,
      backdropClassName = _ref.backdropClassName,
      bodyProps = _ref.bodyProps,
      children = _ref.children,
      className = _ref.className,
      contentProps = _ref.contentProps,
      cssNamespace = _ref.cssNamespace,
      footerProps = _ref.footerProps,
      headerProps = _ref.headerProps,
      onClose = _ref.onClose,
      show = _ref.show,
      size = _ref.size,
      title = _ref.title,
      type = _ref.type,
      props = (0, _objectWithoutProperties2.default)(_ref, ["actions", "backdropClassName", "bodyProps", "children", "className", "contentProps", "cssNamespace", "footerProps", "headerProps", "onClose", "show", "size", "title", "type"]);
  var bodyElm = document.querySelector('body');

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      onClose(event);
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleKeyPress, false);
    return function () {
      return document.removeEventListener('keydown', handleKeyPress, false);
    };
  }, []);
  var icon;

  if (type === 'confirmation') {
    icon = 'question-mark';
  } else if (type === 'error') {
    icon = 'message-error';
  } else if (type === 'success') {
    icon = 'message-success';
  } else if (type === 'warning') {
    icon = 'message-warning';
  } else if (type === 'information') {
    icon = 'message-information';
  }

  if (!show) {
    return null;
  }

  var boxClasses = classnames("".concat(cssNamespace, "-message-box"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = "".concat(cssNamespace, "-message-box--")).call(_context, type), type !== 'default'), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-message-box--active"), show), _classnames), className);
  var contentClasses = classnames("".concat(cssNamespace, "-message-box__content"), (0, _defineProperty2.default)({}, (0, _concat.default)(_context2 = "".concat(cssNamespace, "-message-box__content--")).call(_context2, size), size));
  var bodyClasses = classnames("".concat(cssNamespace, "-message-box__body"));
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_reactFocusLock.default, {
    as: "div",
    className: backdropClassName,
    lockProps: _objectSpread({}, props)
  }, _ref2, /*#__PURE__*/_react.default.createElement("div", {
    className: boxClasses
  }, /*#__PURE__*/_react.default.createElement("section", (0, _extends2.default)({
    className: contentClasses
  }, contentProps), /*#__PURE__*/_react.default.createElement(_Bar.default, (0, _extends2.default)({
    className: classnames("".concat(cssNamespace, "-message-box__header")),
    leftComponents: [/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      glyph: icon
    }), /*#__PURE__*/_react.default.createElement(_Title.default, {
      level: 2,
      levelStyle: 5
    }, title))],
    type: "header"
  }, headerProps)), /*#__PURE__*/_react.default.createElement("section", (0, _extends2.default)({
    className: bodyClasses
  }, bodyProps), children), /*#__PURE__*/_react.default.createElement(_Bar.default, (0, _extends2.default)({
    className: classnames("".concat(cssNamespace, "-message-box__footer")),
    rightComponents: (0, _map.default)(actions).call(actions, function (child) {
      var _child$props, _child$props2;

      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        className: classnames((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.className, "".concat(cssNamespace, "-message-box__decisive-button")),
        onClick: (0, _chainFunction.default)(onClose, (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.onClick)
      });
    }),
    type: "footer"
  }, footerProps))))), bodyElm);
}

process.env.NODE_ENV !== "production" ? MessageBox.propTypes = {
  /** Node(s) to render within the footer of the dialog */
  actions: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,

  /** Localized text for the heading */
  title: _propTypes.default.string.isRequired,

  /** CSS class(es) to add to the dialog backdrop */
  backdropClassName: _propTypes.default.string,

  /** Additional props to be spread to the body section of the dialog */
  bodyProps: _propTypes.default.object,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Additional props to be spread to the content section of the dialog */
  contentProps: _propTypes.default.object,

  /** Additional props to be spread to the footer of the dialog */
  footerProps: _propTypes.default.object,

  /** Additional props to be spread to the header of the dialog */
  headerProps: _propTypes.default.object,

  /** Set to **true** to make the dialog visible */
  show: _propTypes.default.bool,

  /** By default dialog body has no horizontal paddings. Add a size to modify the padding: 's', 'm', 'l', 'xl' */
  size: _propTypes.default.oneOf(_constants.DIALOG_SIZES),

  /** Message box type */
  type: _propTypes.default.oneOf(MESSAGE_BOX_TYPES),

  /** Callback function; triggered when dialog closes either due to `Escape` keydown or any of the actions' `onClick`.
   * `onClose` is executed BEFORE any of the actions' `onClick` handler.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
   */
  onClose: _propTypes.default.func
} : void 0;
MessageBox.defaultProps = {
  type: 'default',
  onClose: function onClose() {}
};

var _default = (0, _withStyles.default)(MessageBox);

exports.default = _default;